.previewModal {
	font-family: Arial, sans-serif;
	color: #1f2937;
	background-color: #f9fafb;
	border-radius: 8px;

	h5 {
		font-size: 0.875rem;
		font-weight: 600;
		color: #4b5563;
		margin-bottom: 0.5rem;
	}
}

.title {
	font-size: 16px !important;
	color: #7fb02f;
}

.alert {
	background-color: #fde047;
	color: #92400e;
	font-size: 0.75rem;
	padding: 6px;
	border: 1px solid #facc15;
	border-radius: 4px;
	margin-bottom: 0.75rem;
}

.tableMain {
	display: flex;
	flex-direction: column;
	margin-bottom: 2em;

	.row {
		display: flex;
		justify-content: space-between;
		width: 100%;

		.cell {
			flex: 0 0 50%;
			display: flex;
			flex-direction: column;
			gap: 0.5rem;

			.field {
				display: flex;
				align-items: baseline;
				font-size: 14px;

				strong {
					color: #374151;
					font-weight: 600;
					margin-right: 0.2rem;
				}
			}
		}
	}
}

.tableDetail {
	width: 100%;
	border-collapse: collapse;

	.tableHeader {
		font-weight: 600;
		color: #6b7280;
		background-color: #f3f4f6;

		th {
			border: 1px solid #dee2e6;
			font-size: 12px !important;
			text-align: center;
			padding: 0px 10px;
		}
	}

	.tableRow {
		font-size: 0.875rem;
		color: #374151;

		&:nth-child(even) {
			background-color: #f9fafb;
		}

		td {
			padding: 6px 8px;
			text-align: left;
			border-bottom: 1px solid #e5e7eb;
		}
	}
}

.highlight {
	background-color: #fef9c3;
	font-weight: bold;
}

.total {
	margin-top: 1rem;
	text-align: right;
	font-size: 18px !important;
}
